export type ReadonlyLevelEndpoints = {
    readonly SaveLevel: string;
    readonly GetLevels: string;
    readonly GetLevelById: string;
    readonly UpdateLevel: string;
    readonly DeleteLevel: string;
    readonly GetBuilding : string; 
    readonly checkDeleteInactiveLevel : string; 
    readonly getLevelByBuildingId: string;
    
  };

  const controller = 'api/Level'

  const LevelEndpoints: ReadonlyLevelEndpoints = {
    SaveLevel: `${controller}/AddUpdateLevel`,
    GetLevels: `${controller}/GetLevels`,
    GetLevelById: `${controller}/GetLevelById`,
    UpdateLevel: `${controller}/AddUpdateLevel`,
    DeleteLevel: `${controller}/DeleteLevel`,
    GetBuilding : `api/Building/GetBuildingBySiteId`,
    checkDeleteInactiveLevel: `${controller}/CheckDeleteInactiveLevel`,
    getLevelByBuildingId: `${controller}/GetLevelByBuildingId`,
  };
  
  export { LevelEndpoints };